<template>
  <boxwrap class="agents--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class= 'search-bar-wrap'
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="createPopup()"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0 && checkButtons('delete')"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          @click="restore()"
          v-if="selected.length > 0  && checkButtons('restore')"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          v-if="selected.length > 0 && checkButtons('active')"
          @click="updateStatus(1)"
        >
          <span>active</span>
        </button>

        <button
          class="btn--delete""
          v-if="selected.length > 0 && checkButtons('inactive')"
          @click="updateStatus(0)"
        >
          <span>inactive</span>
        </button>

        <button
          class="btn--modify"
          title="modify"
          v-if="selected.length > 0 && checkButtons('save')"
          @click="update()"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>
          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>

      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(agents)"
                    :checked="selectAll"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                :sort="true"
                name="no"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                :sort="true"
                name="login-id"
                @click.native="sort('login_id')"
                v-if="checkCol('login_id', tblSetting)"
              >
                login id
              </tbl-td>

              <tbl-td
                name="login-name"
                :sort="true"
                @click.native="sort('login_name')"
                v-if="checkCol('login_name', tblSetting)"
              >
                login name
              </tbl-td>

              <tbl-td
                name="level"
                :sort="true"
                @click.native="sort('level_id')"
                v-if="checkCol('level', tblSetting)"
              >
                level
              </tbl-td>

              <tbl-td
                name="phone"
                :sort="true"
                @click.native="sort('phone')"
                v-if="checkCol('phone', tblSetting)"
              >
                phone
              </tbl-td>

              <tbl-td
                class="vip"
                :sort="true"
                @click.native="sort('vip_id')"
                v-if="checkCol('vip', tblSetting)"
              >
                vip
              </tbl-td>

              <tbl-td
                class="bank-name"
                :sort="true"
                @click.native="sort('banks.name')"
                v-if="checkCol('bank_details', tblSetting)"
              >
                bank name
              </tbl-td>

              <tbl-td
                class="bank-account-name"
                :sort="true"
                @click.native="sort('bank_account_name')"
                v-if="checkCol('bank_details', tblSetting)"
              >
                bank account name
              </tbl-td>

              <tbl-td
                class="bank-number"
                :sort="true"
                @click.native="sort('bank_account_number')"
                v-if="checkCol('bank_details', tblSetting)"
              >
                bank account number
              </tbl-td>

              <tbl-td
                class="referrer"
                v-if="checkCol('referrer', tblSetting)"
              >
                referrer
              </tbl-td>

              <tbl-td
                :sort="true"
                @click.native="sort('balance')"
                class="balance"
                v-if="checkCol('balance', tblSetting)"
              >
                balance
              </tbl-td>

              <tbl-td
                class="points"
                :sort="true"
                @click.native="sort('point')"
                v-if="checkCol('point', tblSetting)"
              >
                points
              </tbl-td>

              <tbl-td
                class="status"
                v-if="checkCol('status', tblSetting)"
              >
                status
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(agent, x) in agents"
              :key="x"
              :class="{'is-deleted': agent.deleted_at }"
            >
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="agent.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ agent.id }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ agent.created_at | date }}
              </tbl-td>

              <tbl-td
                class="login-id"
                @click.native="openAgent(agent.id)"
                v-if="checkCol('login_id', tblSetting)"
              >
                {{ agent.login_id }}
              </tbl-td>

              <tbl-td
                class="login-name"
                v-if="checkCol('login_name', tblSetting)"
              >
                {{ agent.login_name }}
              </tbl-td>

              <tbl-td
                class="level"
                v-if="checkCol('level', tblSetting)"
              >
                <select-list
                  :title="agent.level.name"
                  :withReset="true"
                  v-model="agent.level_id"
                  v-if="checkPermission"
                  @reset="resetTrigger(agent)"
                >
                  <select-option
                    v-for="level in levels"
                    :key="level.id"
                    :value="level.id"
                    :name="level.name"
                    @click.native="setSelected(agent, 'level_id')"
                  >
                    {{ level.name }}
                  </select-option>
                </select-list>
                <span v-else>{{ agent.level.name }}</span>
              </tbl-td>

              <tbl-td
                class="phone"
                v-if="checkCol('phone', tblSetting)"
              >
                {{ agent.phone }}
              </tbl-td>

              <tbl-td
                class="vip"
                v-if="checkCol('vip', tblSetting)"
              >
                <select-list
                  :title="agent.vip_id | formatVip"
                  :withReset="true"
                  v-model="agent.vip_id"
                  v-if="checkPermission"
                  @reset="resetTrigger(agent)"
                >
                  <select-option
                    v-for="vip in vipList"
                    :value="vip.id"
                    :key="vip.id"
                    :name="vip.name"
                    @click.native="setSelected(agent, 'vip_id')"
                  >
                    {{ vip.name }}
                  </select-option>
                </select-list>
                <span v-else>{{ agent.vip_id | formatVip }}</span>
              </tbl-td>

              <tbl-td
                class="bank-name"
                v-if="checkCol('bank_details', tblSetting)"
              >
                <span v-if="agentWallets[agent.id]">{{agentWallets[agent.id].bank_name}}</span>
              </tbl-td>

              <tbl-td
                class="bank-account-name"
                v-if="checkCol('bank_details', tblSetting)"
              >
                <span v-if="agentWallets[agent.id]">{{agentWallets[agent.id].bank_account_name}}</span>
              </tbl-td>

              <tbl-td
                class="bank-number"
                v-if="checkCol('bank_details', tblSetting)"
              >
                <span v-if="agentWallets[agent.id]">{{agentWallets[agent.id].bank_number}}</span>
              </tbl-td>

              <tbl-td
                class="referrer"
                v-if="checkCol('referrer', tblSetting)"
              >
                <template v-if="agent.referrer">
                  {{ agent.referrer.referrer_name }}
                </template>

                <template v-if="!agent.referrer">-</template>
              </tbl-td>

              <tbl-td
                class="balance"
                v-if="checkCol('balance', tblSetting)"
              >
                {{ agent.balance | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="points"
                v-if="checkCol('point', tblSetting)"
              >
                {{ agent.point | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="status"
                v-if="checkCol('status', tblSetting)"
              >
                <span v-if="agent.active">active</span>
                <span v-if="!agent.active">inaactive</span>
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ agent.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ agent.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="agentsCount"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-agents"
      title="create agents"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-head">
          <div class="form-lbl"><span>user count</span></div>
          <div class="form-data">
            <div class="input-wrap">
              <input v-model.number="count" />
            </div>
          </div>
        </div>

        <div
          class="form-con"
          v-for="(agent, x) in manualUsers"
          :key="x"
        >
          <div class="form-items">
            <div class="form-lbl"><span>login id</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_id')}"
              >
                <input placeholder="login id" v-model="agent.login_id" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>login name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_name')}"
              >
                <input placeholder="login name" v-model="agent.login_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'password')}"
              >
                <input placeholder="password" v-model="agent.password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>phone</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'phone')}"
              >
                <input placeholder="phone" v-model="agent.phone" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_account_name')}"
              >
                <input placeholder="bank account name" v-model="agent.bank_account_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank number</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_number')}"
              >
                <input placeholder="bank number" v-model="agent.bank_number" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_password')}"
              >
                <input placeholder="bank password" v-model="agent.bank_password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="form-data">
              <select-list
                :title="banks[0].name"
                :withReset="true"
                v-model="agent.bank_id"
                @reset="resetTrigger(agent)"
              >
                <select-option
                  :value="bank.id"
                  :name="bank.id"
                  v-for="(bank, e) in banks"
                  :key="e"
                >
                  {{ bank.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>currency</span></div>
            <div class="form-data">
              <select-list
                :title="'USD'"
                :withReset="true"
                v-model="agent.currency_id"
                @reset="resetTrigger(agent)"
              >
                <select-option
                  value="1"
                  name="USD"
                >
                  USD
                </select-option>
                <select-option
                  value="2"
                  name="JPY"
                >
                  JPY
                </select-option>
                <select-option
                  value="2"
                  name="KRW"
                >
                  KRW
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'agents-management',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList
  },

  filters: {
    FormatAmount,

    formatVip (vip) {
      let v = ''

      switch (vip) {
        case 1:
          v = 'normal'
          break
        case 2:
          v = 'vip'
          break
        case 3:
          v = 'vvip'
          break
      }

      return v
    }
  },

  mixins: [ swal, checkAll ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    return {
      params,
      agents: [],
      manualUsers: [],
      count: 1,
      selected: [],
      selectAll: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      showTblSettings: false,
      showCreate: false,
      showSub: false,

      filterBy: [
        {
          value: 'login_name',
          display: 'name'
        },

        {
          value: 'login_id',
          display: 'username'
        },

        {
          value: 'phone',
          display: 'phone'
        },

        {
          value: 'balance',
          display: 'balance'
        },
        {
          value: 'bank_account_name',
          display: 'bank account name'
        },

        {
          value: 'bank_account_number',
          display: 'bank number'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'agent_list',
      allCols: [
        {
          value: 'id',
          display: 'no'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'login_id',
          display: 'login id'
        },
        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'level',
          display: 'level'
        },
        {
          value: 'phone',
          display: 'phone'
        },
        {
          value: 'vip',
          display: 'vip'
        },
        {
          value: 'bank_details',
          display: 'bank details'
        },
        {
          value: 'wallets',
          display: 'wallets'
        },
        {
          value: 'referrer',
          display: 'referrer'
        },
        {
          value: 'balance',
          display: 'balance'
        },
        {
          value: 'point',
          display: 'points'
        },
        {
          value: 'status',
          display: 'status'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      validation: []
    }
  },

  computed: {
    ...mapState('agent', { allAgents: 'agents', agentsCount: 'count' }),
    ...mapState('bank', ['banks']),
    ...mapState('vip', ['vipList']),
    ...mapState('level', ['levels']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    agentWallets () {
      let wallets = {}

      this.allAgents.forEach((e) => {
        wallets[e.id] = e.wallets.find((wal) => {
          return wal.is_main
        })
      })

      return wallets
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.search(this.generate(this.params))
    await this.getBanks({ status: 'active' })
    await this.getVips()
    await this.getLevels()
  },

  watch: {
    async '$route' ($router) {
      this.showDataLoading = true
      this.params = this.generate(this.params)
      this.search()
    },

    count () {
      this.showSub = false
      this.createPopup()
    }
  },

  methods: {
    ...mapActions('agent', {
      getAgents: 'get',
      patch: 'update',
      createAgents: 'create',
      deleteAgent: 'delete'
    }),
    ...mapActions('bank', { getBanks: 'get' }),
    ...mapActions('vip', { getVips: 'get' }),
    ...mapActions('level', { getLevels: 'get' }),

    checkButtons (key) {
      if (this.$route.params.status === 'all') {
        return true
      }

      let allowed = {
        'active': ['save', 'inactive'],
        'inactive': ['save', 'active', 'delete'],
        'deleted': ['restore']
      }

      if (allowed[this.$route.params.status].indexOf(key) >-1) {
        return true
      }

      return false
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == reset flag
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      this.isEmpty = false
      this.selected = []
      this.selectAll = false

      await this.getAgents({ params: this.params, status: this.$route.params.status })
      this.agents = JSON.parse(JSON.stringify(this.allAgents))
      // == set flag
      if (!this.agents.length) {
        this.isEmpty = true
      }
      this.showDataLoading = false
      this.isDataLoading = false
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.$router.push({ query: this.params })
    },

    async create () {
      let success = async () => {
        try {
          this.showDataLoading = true
          await this.createAgents(this.manualUsers)
          this.$alert('success', 'You have successfully created a new agent.', {}, '', 'Success')

          this.showCreate = false
          this.search()
        } catch (err) {
          this.$alert('error', err, {}, '', 'Error')
        }
      }

      for (var x = 0; x < this.manualUsers.length; x++) {
        for (var key in this.manualUsers[x]) {
          if (this.manualUsers[x][key] === '') {
            this.validation.push({
              index: x,
              value: key
            })
          }
        }
      }

      if (this.validation.length) {
        alert('pls check ur  inputs')
        setTimeout(() => {
          this.validation = []
        }, 3000)
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Agent')
    },

    async update () {
      let success = async () => {
        let keys = ['level_id', 'vip_id', 'active']

        this.showDataLoading = true

        let edited = this.agents.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < edited.length; x++) {
          let data = {}

          for (var key in edited[x]) {
            if (keys.indexOf(key) > -1) {
              data[key] = edited[x][key]
            } // end if
          } // end for

          try {
            await this.patch({ data: data, id: edited[x].id })
          } catch (err) {

          }
        } // end for

        this.showDataLoading = false
        this.search()

        if (!this.agents.length) {
          this.isEmpty = true
        }
      }

      this.$alert('prompt', 'Are you sure you want to modify the following agent(s)?', {}, { success }, 'Modify Agent(s)')
    },

    updateStatus (active) {
      this.agents.forEach((e) => {
        if (this.selected.indexOf(e.id) > -1) {
          e.active = active
        }
      })

      this.update()
    },

    async deleteData () {
      let success = async () => {
        for (var x = 0; x < this.selected.length; x++) {
          await this.deleteAgent(this.selected[x])
        }
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to delete the following agent(s)?', {}, { success }, 'Modify Agent(s)')
    },

    async restore () {
      let success = async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.patch({
            id: this.selected[x],
            data: {
              deleted_at: null
            }
          })
        }

        this.selectAll = false
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to restore the following user(s)?', {}, { success }, 'Restore Agent(s)')
    },

    checkValidation (val, key) {
      if (this.validation.length) {
        let filter = this.validation.filter((e) => {
          return parseInt(e.index) === parseInt(val)
        })

        let find = filter.find((e) => {
          return e.value === key
        })

        return !!find
      }
      return false
    },

    createPopup () {
      this.showCreate = true

      this.manualUsers = []
      for (var x = 0; x < this.count; x++) {
        this.manualUsers.push({
          login_id: '',
          login_name: '',
          phone: '',
          password: '',
          bank_account_name: '',
          bank_number: '',
          bank_password: '',
          bank_id: 1,
          currency_id: 1,
          code: '',
          addCode: false
        })
      }
    },

    setSelected (agent) {
      this.$nextTick(() => {
        let result = this.allAgents.find((row) => {
          return row.id === agent.id
        })

        let idx = this.selected.indexOf(agent.id)

        if (agent.level_id === result.level_id &&
            agent.vip_id === result.vip_id &&
            agent.status === result.status &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (agent.level_id === result.level_id &&
          agent.vip_id === result.vip_id &&
          agent.status === result.status) {
          return
        }

        this.selected.push(agent.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    resetTrigger (agent) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(agent.id)

        let result = this.allAgents.find((row) => {
          return row.id === agent.id
        })

        if (result.level_id !== agent.level_id) {
          count += 1
        }

        if (result.vip_id !== agent.vip_id) {
          count += 1
        }

        if (result.status !== agent.status) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    },

    openAgent (id) {
      window.open(
        `${process.env.VUE_APP_URL}/agent/${id}/info/undeleted`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
